class Tabs {
  root: HTMLElement;
  tabs: HTMLElement[];
  panels: HTMLElement[];

  constructor(root: HTMLElement) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll<HTMLElement>('[role="tab"]'));
    this.panels = Array.from(
      root.querySelectorAll<HTMLElement>('[role="tabpanel"]')
    );
    this.bindEvents();
    // 初期表示
    this.activateTab(0);
  }

  bindEvents() {
    this.tabs.forEach((tab, idx) => {
      tab.addEventListener('click', () => this.activateTab(idx));
    });
  }

  activateTab(newIndex: number) {
    this.tabs.forEach((t, i) => {
      const selected = i === newIndex;
      t.classList.toggle('active', selected);
      t.tabIndex = selected ? 0 : -1;
    });

    this.panels.forEach((p, i) => {
      const visible = i === newIndex;
      p.classList.toggle('active', visible);
      p.classList.toggle('hidden', !visible); // ← こちらで非表示制御
    });
  }
}

// DOMContentLoaded で初期化
document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('tab-course');
  if (el) new Tabs(el);
});
